





















































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {mapGetters} from "vuex";

import Feed from "@/components/timeline/_feed.vue";
import Timeline from "@/components/timeline/_timeline.vue";
import {Swiper, SwiperSlide} from "vue-awesome-swiper";
import {execCommandCopy} from "@/script/util";
import Toast from "@/script/message";
import {AxiosError} from "axios";

@Component({
    components: {
        Feed, Timeline, Swiper,
        SwiperSlide
    },
})
export default class GameTimeline extends Vue {
    toast = new Toast();
    games: any[] = [];
    totalGameCnt = 0;

    TASswiperOption = {
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: {
            nextEl: '.ta-screenshot .swiper-button-next',
            prevEl: '.ta-screenshot .swiper-button-prev'
        },
    }
    gamePath = this.$route.params.gamePath;
    user: any = '';
    game: any = this.$store.getters.gameInfo;
    imgSrc = '';
    hashtags = [];


    async mounted() {
        await this.$store.dispatch("loginState");
        this.fetch();

    }

    fetch() {

        this.$api.gameInfo(this.gamePath)
            .then((res: any) => {
                const {result} = res;
                const {game} = result;
                this.$store.commit('gameInfo', game)
                this.game = game;
                this.user = game.user
                this.hashtags = (game.hashtags.length > 0) ? game.hashtags.split(",") : undefined;

                this.$store.commit('currPage', {
                    game_id: game.id
                })

                this.$gtag.event('visit_game_page', {
                    'gameId': game.id,
                });
                this.gameListFetch();


            })
            .catch((err: any) => {


            })
    }


    gameListFetch() {
        this.$api.userChannel(this.user.channel_id)
            .then((res: any) => {
                const {target} = res;
                const {games} = target;
                this.$store.commit('gameList', games)
                if (games.length > 0) {
                    this.totalGameCnt = games.length;
                }
                this.games = games.slice(0, 5)
            })
            .catch((err: AxiosError) => {
                // this.$router.push(`/${this.$i18n.locale}`)
                // console.log('err', err)
            })


    }

    beforeDestroy() {
        this.$store.commit('currPage', null)
    }

    openImgModal(imgSrc: string) {
        this.imgSrc = imgSrc;
        (this.$refs.originScreenShootImgModal as any).show();
    }

    closeImgModal() {
        (this.$refs.originScreenShootImgModal as any).hide();
    }

    copyUrl() {
        const url = `${process.env.VUE_APP_LAUNCHER_URL}game/${this.game.pathname}`;
        execCommandCopy(url)
        this.toast.clear();
        this.toast.successToast(`${this.$t('copied.clipboard')}`)
    }

    moveGamePage(pathname: string) {
        this.$router.push(`/${this.$i18n.locale}/timeline/game/${pathname}`)
    }

    @Watch('$route.params.gamePath')
    watchParams() {
        this.gamePath = this.$route.params.gamePath
        this.fetch();
    }
}
